import { TestedParty } from '../tested-party';
import { Characterization } from '../characterization';

export class CharacterizeTestedPartyModalPayload {
  testedParty: TestedParty;
  characterization: Characterization;
}
